import { render } from "./FeedbackTable.vue?vue&type=template&id=be3db59e"
import script from "./FeedbackTable.vue?vue&type=script&lang=ts"
export * from "./FeedbackTable.vue?vue&type=script&lang=ts"
script.render = render

export default script